import { translate } from 'angular';
import { IEmailConfirmationConfig } from './emailConfirmation.config';
export default function anFn_17927(emailConfirmationConfig: IEmailConfirmationConfig, $translate: translate.ITranslateService) {
  emailConfirmationConfig.emailConfirmedText = $translate.instant('Js.EmailConfirmation.EmailConfirmedText');
  emailConfirmationConfig.emailNotConfirmedText = $translate.instant('Js.EmailConfirmation.EmailNotConfirmedText');
}
anFn_17927.$inject = ["emailConfirmationConfig", "$translate"];
;